var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHiking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.000000pt",
    height: "48.000000pt",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 464 c-9 -8 -16 -22 -16 -29 0 -18 27 -45 45 -45 18 0 45 27 45 45 0 18 -27 45 -45 45 -7 0 -21 -7 -29 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 373 c-24 -20 -58 -130 -44 -144 5 -5 24 -10 43 -11 l34 -3 22 80 c12 43 20 83 18 87 -9 14 -51 9 -73 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 348 c-23 -18 -52 -133 -39 -156 5 -9 25 -33 45 -51 30 -29 36 -42 36 -75 0 -54 13 -75 37 -60 12 7 19 26 21 54 3 43 -13 100 -29 100 -17 0 -30 41 -23 75 6 33 7 34 27 20 12 -8 32 -15 44 -15 22 0 23 -3 23 -82 0 -118 8 -158 31 -158 18 0 19 11 19 165 0 158 -1 165 -20 165 -11 0 -20 -7 -20 -15 0 -24 -30 -17 -67 15 -36 32 -60 37 -85 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 90 c-10 -51 -10 -74 -2 -82 20 -20 40 1 53 56 11 50 10 58 -6 76 -10 11 -21 20 -25 20 -4 0 -13 -32 -20 -70z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiking);
export default __webpack_public_path__ + "static/media/hiking.c49a1b6820f88127bf43da012899471c.svg";
export { ForwardRef as ReactComponent };